import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import DocumentViewer from '../../../components/Drivers/DocumentViewer/DocumentViewer';
import Link from '../../../components/Link';

import s from './DriverDocuments.css';
import bt from '../../../components/commonStyle.css';

class DriverDocuments extends Component {

  render() {
    const { title, driverId } = this.props;

    return (
      <div className={cx(s.root, bt.space2)}>
        <div className={cx(s.container, bt.space2)}>
          <div className={cx(bt.space5, s.spaceTop3)}>
            <div className={cx(s.sectionTitle, bt.displayTable, bt.width100)}>
              <div className={bt.displayTableCell}>
                <div className={s.panelHeader}>
                  <h1 className={cx(s.headerTitle, bt.space0, bt.spaceTop1)}>{title}</h1>
                  <div className={s.breadcrumb}>
                    <Link to="/siteadmin/drivers" className={s.breadcrumbLink}>
                      ← Back to Drivers List
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
            <div className={cx(bt.space2, s.exportSection, bt.displayInlineBlock)}>
              <div className="clearfix"></div>
            </div>
            
            <DocumentViewer driverId={driverId} />
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  loading: state.intl.loading
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(DriverDocuments)));